import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MaxWidthPageImage from 'components/MaxWidthPageImage';
import MediaTypography from 'components/MediaTypography';
import Page from 'components/Page';
import { getRoute } from '@common/constants/CampusRoutes';

import GoalsImageSrc from '@common/assets/images/about-me/goals/goals_lg.jpg';
import useModel from '@common/helpers/useModel';
import MainGoalModel, { IMainGoalModel } from '@common/models/Goals/MainGoal';

import GoalsForm from './Form';
import { StyledGoalsInnerWrap } from './styled';

function GoalsPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [isEditing, setIsEditing] = useState(false);
	const [loading, setLoading] = useState(false);

	const mainGoalModel: IMainGoalModel = useModel(MainGoalModel, {}, [], { disableFetch: true });

	const handleGoBack = () => {
		navigate(getRoute(['REPORT', 'ABOUT']));
	};

	const handleIsEditing = (value: boolean) => () => {
		setIsEditing(value);
	};

	useEffect(() => {
		const getMainGoal = async () => {
			try {
				setLoading(true);
				await mainGoalModel.fetch();
				!mainGoalModel.id && navigate(getRoute(['REPORT', 'ABOUT', 'GOALS', 'CREATE']));
			} finally {
				!mainGoalModel.id && navigate(getRoute(['REPORT', 'ABOUT', 'GOALS', 'CREATE']));
				setLoading(false);
			}
		};

		getMainGoal();
	}, []);

	return (
		<Page
			type="content"
			sx={{ position: 'relative' }}
			title="Goals"
			onGoBack={handleGoBack}
			isLoading={mainGoalModel.loading || loading}
		>
			<MediaTypography variant="h3" textColor="secondary">
				{t('report.goals.specifycResults')}
			</MediaTypography>
			<StyledGoalsInnerWrap>
				<GoalsForm
					isEditing={isEditing}
					onSetIsEditing={handleIsEditing}
					mainGoalModel={mainGoalModel}
				/>
				<MaxWidthPageImage alt="Main Goals image" src={GoalsImageSrc} />
			</StyledGoalsInnerWrap>
		</Page>
	);
}

export default observer(GoalsPage);
